(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('DoctorSpecialty', DoctorSpecialty);

    DoctorSpecialty.$inject = ['$resource'];

    function DoctorSpecialty ($resource) {
        var resourceUrl =  'api/doctor-specialties/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
